import {
  Compass,
  Download,
  Disc3,
  Heart,
  Home,
  LayoutGrid,
  ListMusic,
  Mic2,
  Music,
  Newspaper,
  Podcast,
  Search,
  Sparkles,
  Video,
} from "lucide-react";

/** Primary destinations — home, explore, search. */
export const NAV_ITEMS = [
  { href: "/", title: "خانه", icon: Home },
  { href: "/browse", title: "کاوش", icon: Compass },
  { href: "/search", title: "جستجو", icon: Search },
] as const;

/** Catalogue, directly under search. */
export const DISCOVER_ITEMS = [
  { href: "/podcasts", title: "پادکست", icon: Podcast },
  { href: "/videos", title: "نماهنگ", icon: Video },
  { href: "/artists", title: "هنرمند", icon: Mic2 },
  { href: "/categories", title: "دسته‌بندی", icon: LayoutGrid },
] as const;

/** Smaller tail of the menu. */
export const MORE_ITEMS = [
  { href: "/blog", title: "وبلاگ", icon: Newspaper },
  { href: "/plans", title: "اشتراک", icon: Sparkles },
  { href: "/download", title: "دانلود اپ", icon: Download },
] as const;

/** Name of the listener's own collection (likes, playlists, saves, follows). */
export const LIBRARY_TITLE = "موسیقی من";

/** "موسیقی من" — the listener's own collection (sign-in required). */
export const LIBRARY_ITEMS = [
  { href: "/library/liked", title: "پسندیده‌ها", icon: Heart },
  { href: "/library/playlists", title: "پلی‌لیست‌ها", icon: ListMusic },
  { href: "/library/songs", title: "ذخیره‌شده‌ها", icon: Music },
  { href: "/library/podcasts", title: "پادکست‌ها", icon: Podcast },
  { href: "/library/videos", title: "نماهنگ‌ها", icon: Video },
  { href: "/library/artists", title: "هنرمندان", icon: Mic2 },
  { href: "/library/albums", title: "آلبوم‌ها", icon: Disc3 },
] as const;

export { ListMusic };

export function isActivePath(pathname: string, href: string): boolean {
  return href === "/" ? pathname === "/" : pathname === href || pathname.startsWith(`${href}/`);
}
